<template>
  <div  v-if="visible" :class="['tooltip-container', { 'horizontal': tooltipPosition === 'left' || tooltipPosition === 'right' }]" :style="positionStyle">
    <div class="tooltip-arrow">
      <svg v-if = "tooltipPosition === 'bottom'" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
        <path d="M5.19618 9.31099e-07L10.3923 5.25L3.05176e-05 5.25L5.19618 9.31099e-07Z" fill="#666666"/>
      </svg>
      <svg v-else-if = "tooltipPosition === 'top'" class="rotate-180" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
        <path d="M5.19618 9.31099e-07L10.3923 5.25L3.05176e-05 5.25L5.19618 9.31099e-07Z" fill="#666666"/>
      </svg>
      <svg v-else-if = "tooltipPosition === 'right'" xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
        <path d="M2.49706e-07 5.19615L5.25 0L5.25 10.3923L2.49706e-07 5.19615Z" fill="#666666"/>
      </svg>
      <svg v-else-if = "tooltipPosition === 'left'" class="rotate-180" xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
        <path d="M2.49706e-07 5.19615L5.25 0L5.25 10.3923L2.49706e-07 5.19615Z" fill="#666666" transform="rotate(180 3 5.19615)"/>
      </svg>
    </div>
    
    <div :class="['tooltip-content', tooltipPosition]">
      <div class="tooltip-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldTooltip',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'This field is for your patients to fill. You can change the placeholder text in the property panel.'
    },
    positionStyle: {
      type: String,
      default: 'position: absolute; top: 80%; left: 50%; transform: translateX(-50%);'
    },
    tooltipPosition: {
      // bottom, top, left, right
      type: String,
      default: 'bottom'
    }
  }
};
</script>

<style scoped>
.tooltip-container {
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.horizontal {
  flex-direction: row;
  align-items: center;
}

.rotate-180 {
  transform: rotate(180deg);
}

.tooltip-content {
  background: #666;
  border-radius: 2px;
  padding: 2px 16px;
  color: #FFFFFF;
  max-width: 240px;
  width: fit-content;
  display: flex; 
  flex-direction: column;
}
.tooltip-content.bottom {
  margin-top: -1px;
}
.tooltip-content.top {
  margin-bottom: -1px;
}
.tooltip-content.left {
  margin-right: -1px;
}
.tooltip-content.right {
  margin-left: -1px;
}

.tooltip-text {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #FFFFFF;
  max-width: 100%;
  width: fit-content;
}
</style>
